<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    title="Signature manuelle"
    v-bind:no_close_btn="true"
    v-bind:no_outside_click="true">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[12px]">
        <span>
          Vous allez basculer sur le processus de signature manuelle.<br />
          Vous devrez téléverser la version signée {{ props.document }}
          <span class="font-bold">manuellement</span>.
        </span>
        <span class="font-bold">Que souhaitez-vous faire ?</span>
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        variant="text"
        v-bind:on_click="props.on_close">
        Signature électronique
      </refonte-button>
      <refonte-button v-bind:on_click="props.on_ok">
        Signature manuelle
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      on_ok: Function;
      class?: string;
      document: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
